import React from 'react';
import ReactDOM from 'react-dom';
import { CVBuilderContextProvider } from './context';
import { CVBuilder } from './cvbuilder';

document.querySelectorAll(".cv-builder").forEach((elem) => {
    const matrixUserData = JSON.parse(elem.getAttribute('data-js-matrixUser'))

    ReactDOM.render(
        <CVBuilderContextProvider>
            <CVBuilder matrixUserData={matrixUserData} />
        </CVBuilderContextProvider>
    , elem);
});
